import { render, staticRenderFns } from "./OrderSummaryHeader.vue?vue&type=template&id=2378bf03&scoped=true"
import script from "./OrderSummaryHeader.vue?vue&type=script&lang=js"
export * from "./OrderSummaryHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderSummaryHeader.vue?vue&type=style&index=0&id=2378bf03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2378bf03",
  null
  
)

export default component.exports